// import { combineReducers, configureStore } from "@reduxjs/toolkit";
// import authReducer from "./slices/auth/authSlice";
// import adminBackgroundReducer from "./slices/adminBackgroundSlice/adminBackgroundSlice";
// import paymentSourceTypeReducer from "./slices/paymentSourceType/paymentSourceTypeSlice";
// import myStripePaymentReducer from "./slices/myStripePayment/myStripePaymentSlice";
// import planTypeReducer from "./slices/planType/planTypeSlice";
// import onchainDepositReducer from "./slices/elanPay/onChainDepositSlice"; // NEW
// import invoiceSessionReducer from "@/store/slices/invoiceSessionSlice/invoiceSessionSlice";
// import { encryptTransform } from "redux-persist-transform-encrypt";

// import {
//   persistStore,
//   persistReducer,
//   FLUSH,
//   REHYDRATE,
//   PAUSE,
//   PERSIST,
//   PURGE,
//   REGISTER,
// } from "redux-persist";
// import storage from "redux-persist/lib/storage";

// // Combine all reducers
// const rootReducer = combineReducers({
//   auth: authReducer,
//   adminBackground: adminBackgroundReducer,
//   planType: planTypeReducer,
//   paymentSource: paymentSourceTypeReducer,
//   myStripePayment: myStripePaymentReducer,
//   onchainDeposit: onchainDepositReducer, // NEW — persisted automatically (no whitelist)
//   invoiceSession: invoiceSessionReducer,
// }) as unknown as typeof rootReducer;

// const encryptor = encryptTransform({
//   secretKey: import.meta.env.VITE_STORAGE_ENCRYPTION_SECRET,
//   onError: (error) => {
//     console.error("Encryption error:", error);
//   },
// });

// const persistConfig = {
//   key: "root",
//   version: 1,
//   storage,
//   transforms: [encryptor], // 🔐 encrypts/decrypts automatically
// };

// const persistedReducer = persistReducer(persistConfig, rootReducer);

// export const store = configureStore({
//   reducer: persistedReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: {
//         ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
//       },
//     }),
// });

// export const persistor = persistStore(store);

// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;

// ============================================================================
// DESTINATION:  src/store/index.ts
// ACTION:       REPLACE your existing file
// ============================================================================

import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/auth/authSlice";
import adminBackgroundReducer from "./slices/adminBackgroundSlice/adminBackgroundSlice";
import paymentSourceTypeReducer from "./slices/paymentSourceType/paymentSourceTypeSlice";
import myStripePaymentReducer from "./slices/myStripePayment/myStripePaymentSlice";
import planTypeReducer from "./slices/planType/planTypeSlice";
import onchainDepositReducer from "./slices/elanPay/onChainDepositSlice";
import invoiceSessionReducer from "@/store/slices/invoiceSessionSlice/invoiceSessionSlice";
import { encryptTransform } from "redux-persist-transform-encrypt";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

// Combine all reducers
const rootReducer = combineReducers({
  auth: authReducer,
  adminBackground: adminBackgroundReducer,
  planType: planTypeReducer,
  paymentSource: paymentSourceTypeReducer,
  myStripePayment: myStripePaymentReducer,
  onchainDeposit: onchainDepositReducer,
  invoiceSession: invoiceSessionReducer,
}) as unknown as typeof rootReducer;

const encryptor = encryptTransform({
  secretKey: import.meta.env.VITE_STORAGE_ENCRYPTION_SECRET,
  onError: (error) => {
    console.error("Encryption error:", error);
  },
});

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  transforms: [encryptor],

  /**
   * ============================================================================
   * ▼ ADDED — myStripePayment MUST NOT be persisted.
   * ============================================================================
   * `myStripePayment.clientSecret` is a LIVE payment credential. Persisting it
   * writes it to localStorage — even encrypted, it is a durable copy of a secret
   * that is meant to live only as long as the PaymentIntent. Two concrete
   * problems:
   *
   *   1. It OUTLIVES the intent. A user who returns tomorrow rehydrates a
   *      clientSecret Stripe has already expired, and CardPaymentForm confirms
   *      against a dead secret — a Stripe error nobody can explain from the UI.
   *
   *   2. It is a secret at rest you did not need to keep. The intent is cheap to
   *      recreate on demand; the credential is not worth storing to avoid that.
   *
   * `blacklist` excludes it from persistence while everything else still
   * persists. It stays in the live Redux store for the session — only the
   * write-to-disk is suppressed.
   *
   * ⚠️ If you ever add sessionVersion to myStripePayment too (recommended, so a
   * stale Stripe intent is caught the same way the invoice is), it rides inside
   * this same slice and is covered by this blacklist automatically.
   */
  blacklist: ["myStripePayment"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
